var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"smart__tag inline-flex align-center justify-center px-1 font-medium",class:_vm.tagColor},[_c('span',{staticClass:"inline-block smart__tag--circle ml-1-2 mr-1"}),_vm._v("\n  "+_vm._s(_vm.label)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }